import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';
import FormItemContainer from './FormItemContainer';
import getSupplementalQuestions from './utils/getSupplementalQuestions';
import getControlGroups from './utils/getControlGroups';
import getFormData from './utils/getFormData';
import flatten from './utils/flattenObject';

import DefaultValidation from './utils/DefaultValidation';

class FormBuilder extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            questions: [],
            disabled: false,
            isSameAddress: false,
        };
        this.state = { ...this.props.data, clearThirdLevelSuppQues: []};
        this.controlGroups = getControlGroups(this.state.questions);
        this.initialParams = this.props.initialParams || {};
        this.initialValues = flatten(this.props.initialValues || {});

        Object.keys(this.initialValues).forEach(name => {
            if (typeof this.initialValues[name] === 'string') {
                this.initialValues[name] = this.initialValues[name].trim();
            }
        });

        this.onSubmit = this.onSubmit.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.loadOptions = this.loadOptions.bind(this);
        this.handleSupplementaryHide = this.handleSupplementaryHide.bind(this);
    }

    onSubmit(event) {
        event.preventDefault();

        const state = Object.assign({}, this.state, {addressValues: this.props.addressValues});
        const values = getFormData(state);
        const flatValues = flatten(values);
        const allRequiredArray = [];

        for (const item of this.state.questions) {
            if (item.required == true && !flatValues[item.name]) {
                allRequiredArray.push(item);
            }
        }

        this.props.handleSubmit(values, this.controlGroups, allRequiredArray);
    }

    onFormChange(event) {
        const values = flatten(getFormData(this.state));
        const form = this.state.questions;
        const validAddress = (values.primaryInsuredCity== values.projectCity && values.primaryInsuredAddress2 == values.projectAddress2 && values.primaryInsuredState == values.projectState && values.primaryInsuredZipcode == values.projectZipcode);
        if (values.Address)
        {
        if (values.Address== "true")
        {
        const addressValues={};
        addressValues.projectAddress = this.props.addressValues.primaryInsuredAddress;
        addressValues.projectAddress2 = this.props.addressValues.primaryInsuredAddress2;
        addressValues.projectCity = values.primaryInsuredCity;
        addressValues.projectState = values.primaryInsuredState;
        addressValues.projectZipcode = values.primaryInsuredZipcode;
        this.props.handleAddressChange(addressValues);
        }
        else {
            if (validAddress) {
            var addressValues={};
            addressValues.projectAddress=" ";
            addressValues.projectAddress2=" ";
            addressValues.projectCity="";
            addressValues.projectState="";
            addressValues.projectZipcode="";
           this.props.handleAddressChange && this.props.handleAddressChange(addressValues)
            }
        }
    }
    this.setState({
        isSameAddress: values.Address== "true" ? true : false
    })
        const arr1=["TBD", "N/A"];
        const disable= Object.values(values).find(elem => arr1.includes(elem && elem.toUpperCase().replace(/\s/g, '')))? true : false;
         this.props.submitTitle==="Review Submission" && this.props.handleDisableButton(disable ? "err" : "")
         this.setState({
            disabled: disable

       })
        if (this.props.initialValues) {

        if (this.props.initialValues.type == "oi") {
            (!this.props.isUnderwriter) ?
            form[49].attributes.options = form[49].attributes.optional : form[49].attributes.options = form[49].attributes.default;
        }
       this.setState({
           questions: form
       })
    }
}

    loadOptions(questionSet) {
        const options = this.props.options || {};
        const loadedItems = [];

        const promises = questionSet
            .map((item, idx) => {
                if (
                    item.attributes &&
                    item.attributes.optionsFunc &&
                    options[item.attributes.optionsFunc]
                ) {
                    loadedItems.push(idx);
                    return options[item.attributes.optionsFunc]();
                }
            })
            .filter(item => item);

        return Promise.all(promises).then(resp => {
            resp.map((options3, idx) => {
                questionSet[loadedItems[idx]].attributes.options = options3;
            });

            return questionSet;
        });
    }

    handleSupplementaryHide(questionId, action) {
        let clearThirdLevelSuppQues = !!this.state.clearThirdLevelSuppQues ? this.state.clearThirdLevelSuppQues : [];
        if (questionId && action === 'ADD') {
            clearThirdLevelSuppQues.push(...questionId);
        } else if (questionId && action === "REMOVE" && clearThirdLevelSuppQues.length > 0) {
            clearThirdLevelSuppQues = clearThirdLevelSuppQues.filter(ques => {
                questionId.map(q => {
                    return ques != q
                })
            });
        }
        this.setState({
            clearThirdLevelSuppQues: clearThirdLevelSuppQues
        })
    }

    componentWillMount() {
        const questionsInitial = Object.assign([], this.state.questions);
        const supplementalQuestionsInitial = Object.assign([], this.state.supplementalQuestions);

        Promise.all([
            this.loadOptions(supplementalQuestionsInitial),
            this.loadOptions(questionsInitial)
        ]).then(resp => {
            const supplementalQuestions = resp[0];
            const questions = resp[1];

            this.setState({
                ...this.state,
                questions,
                supplementalQuestions
            });
        });
    }

    render() {
        const { controlGroups } = this;
        const Validation = this.props.Validation || DefaultValidation;

        const result = [];
        let indexBuilder = 0;

        for (const group in controlGroups) {
            const formItemContainers = controlGroups[group].map((item, index) => {
                const closureState = this.state;
                const validationClosure = function() {
                    return getFormData(closureState);
                };

                return (
                    <FormItemContainer
                        key={item.questionId}
                        data={item}
                        supplementalQuestions={this.state.supplementalQuestions}
                        handleFormChange={this.onFormChange}
                        validation={new Validation(validationClosure)}
                        initialParams={this.initialParams}
                        initialValues={this.initialValues}
                        isUnderwriter = {this.props.isUnderwriter}
                        authStates = {this.props.authStates}
                        isSameAddress = {this.state.isSameAddress}
                        clearThirdLevelSuppQues = {this.state.clearThirdLevelSuppQues}
                        handleAddressChange={this.props.handleAddressChange}
                        addressValues={this.props.addressValues}
                        selectedRelations={this.props.selectedRelations}
                        noSupplementTrigger={this.props.noSupplementTrigger}
                        disableOtherField={this.props.disableOtherField}
                        handleRelationChange={this.props.handleRelationChange}
                        handleOtherFieldChange={this.props.handleOtherFieldChange}
                        handleDisableFieldChange={this.props.handleDisableFieldChange}
                        requiredFields={this.props.requiredFields}
                        scrollToRequiredFields={this.props.scrollToRequiredFields}
                        handleSetScrollToRequired={this.props.handleSetScrollToRequired}
                        handleSupplementaryHide={this.handleSupplementaryHide}
                    />
                );
            });

            const questionTitle = () => {
                if (controlGroups[group][0] && controlGroups[group][0].title) {
                    return <div className="questionHeader">{controlGroups[group][0].title}</div>;
                }
                return <div />;
            };

            indexBuilder += 1;
            result.push(
                <div key={indexBuilder}>
                    {questionTitle()}
                    <div className="group">{formItemContainers}</div>
                </div>
            );
        }

        // show button only if the form elements are created
        let button;

        if (this.props.submissionButtons) {
            button = this.props.submissionButtons();
        } else {
            button =
                result.length > 0 ? (
                    <Button type="submit" disabled={this.state.disabled} tabIndex="-1" onFocus={(e) => e.target.blur()}>{this.props.submitTitle || 'Submit'}</Button>
                ) : null;
        }

        return (
            <form
                className={`formBuilderElement ${this.state.name}`}
                name={this.state.name}
                onSubmit={this.onSubmit}
            >
                <div className="form">
                    {result}
                    {this.props.additionalDocuments && this.props.additionalDocuments}
                    {button}
                </div>
            </form>
        );
    }
}

FormBuilder.propTypes = {
    data: PropTypes.object,
    initialValues: PropTypes.object,
    initialParams: PropTypes.object,
    submitTitle: PropTypes.string,
    handleSubmit: PropTypes.func,
    submissionButtons: PropTypes.func
};

export default FormBuilder;
